module.exports = __webpack_public_path__ + "img/Digi_entwurf_6.aaaec0d4.png";